import { OnboardingTrainingCourse } from "../onboarding-training-widget/onboarding-training-widget.types";

export interface OnboardingTrainingSectionProps {
  type?: "card" | "shortcut";
  onClick?: () => void;
}

export interface OnboardingTrainingSectionHookReturn {
  courses: OnboardingTrainingCourse[];
  displayedCourses: OnboardingTrainingCourse[];
  loading: boolean;
  error: string | null;
  isExpanded: boolean;
  showViewMore: boolean;
  onboardingTrainingEnabled: boolean;
  onboardingTrainingShouldShow: boolean;
  onboardingTrainingIsActive: boolean;
  trainingPlatform: string;
  handleToggleExpand: () => void;
  handleSSOClick: (courseId?: string) => void;
  translations: {
    title: string;
    viewMore: string;
    viewLess: string;
    enroll: string;
    inactive: string;
    progress: string; // PHKL Custom
  };
}

/* PHKL Custom -s*/
export const ONBOARDING_TRAINING_COURSES = [
  "E-03D5P1",
  "E-063OK0",
  "E-1LO781",
  "E-0WXLDV",
  "E-0JN39V",
  "E-0Y8NX0",
];
/* PHKL Custom -e*/
